import { apiService } from './apiService';

export const shiftService = {
  // Get all shifts
  async getShifts(params?: { startDate?: string; endDate?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    
    const query = queryParams.toString();
    return await apiService.get(`/shifts${query ? `?${query}` : ''}`);
  },

  // Get shift by ID
  async getShift(id: string | number) {
    return await apiService.get(`/shifts/${id}`);
  },

  // Create shift
  async createShift(data: any) {
    return await apiService.post('/shifts', data);
  },

  // Update shift
  async updateShift(id: string | number, data: any) {
    return await apiService.put(`/shifts/${id}`, data);
  },

  // Delete shift
  async deleteShift(id: string | number) {
    return await apiService.delete(`/shifts/${id}`);
  },

  // Get shift assignments
  async getAssignments(params?: { shiftId?: string; driverId?: string; startDate?: string; endDate?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.shiftId) queryParams.append('shiftId', params.shiftId);
    if (params?.driverId) queryParams.append('driverId', params.driverId);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    
    const query = queryParams.toString();
    return await apiService.get(`/shift-assignments${query ? `?${query}` : ''}`);
  },

  // Create shift assignment
  async createAssignment(data: any) {
    return await apiService.post('/shift-assignments', data);
  },

  // Update shift assignment
  async updateAssignment(id: string | number, data: any) {
    return await apiService.put(`/shift-assignments/${id}`, data);
  },

  // Delete shift assignment
  async deleteAssignment(id: string | number) {
    return await apiService.delete(`/shift-assignments/${id}`);
  },
};
